import type { LearningResource, PassportCriterion } from "@peer-start/platform-contracts";
import { useTranslation } from "react-i18next";
import { VimeoVideo } from "./VimeoVideo.js";

export function LearningResourceParts({
  resource,
  criteria,
}: {
  resource: LearningResource;
  criteria: PassportCriterion[];
}) {
  const { t } = useTranslation();
  const byId = new Map(criteria.map((criterion) => [criterion.id, criterion]));

  return (
    <div className="space-y-4">
      <p className="text-sm leading-relaxed text-muted-foreground">{resource.description}</p>
      {resource.sections.map((section, index) => {
        const targets = (section.coverage ?? []).flatMap((mapping) => {
          const criterion = byId.get(mapping.criterionId);
          return criterion ? [criterion] : [];
        });
        return (
          <section
            className="rounded-xl border border-border p-4"
            key={section.id ?? `${index}-${section.title}`}
          >
            <h4 className="font-medium">{section.title}</h4>
            <p className="mt-1 text-sm leading-relaxed text-muted-foreground">{section.body}</p>
            {section.video?.provider === "vimeo" ? (
              <div className="mt-4">
                <VimeoVideo
                  controlId={`passport.learning.${resource.id}.part.${section.id ?? index}`}
                  title={section.title}
                  videoId={section.video.videoId}
                  startSeconds={section.video.startSeconds}
                  endSeconds={section.video.endSeconds}
                />
              </div>
            ) : null}
            {targets.length ? (
              <div className="mt-4">
                <h5 className="text-sm font-medium">{t("passportVig.lesson.sectionCoverage")}</h5>
                <ul className="mt-2 space-y-1 text-sm text-muted-foreground">
                  {targets.map((criterion) => (
                    <li key={criterion.id}>
                      {t(`passportVig.criteria.${criterion.kind}`)}: {criterion.title}
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </section>
        );
      })}
    </div>
  );
}
